import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=6c5147db&scoped=true"
import script from "./VButton.vue?vue&type=script&lang=ts"
export * from "./VButton.vue?vue&type=script&lang=ts"
import style0 from "./VButton.vue?vue&type=style&index=0&id=6c5147db&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5147db",
  null
  
)

export default component.exports